/* SETTINGS KEY */
export const SETTINGS_KEY_SYSTEM_COLOR = 'systemColor'
export const SETTINGS_KEY_SYSTEM_TITLE = 'systemTitle'
export const SETTINGS_KEY_CLIENT_CATEGORIES_SCREEN_TITLE = 'clientCategoriesScreenTitle'
export const SETTINGS_KEY_CLIENT_CATEGORIES_SCREEN_SUBTITLE = 'clientCategoriesScreenSubtitle'
export const SETTINGS_KEY_ADMIN_INITIAL_RESERVABLE_COUNT = 'adminInitialReservableCount'
export const SETTINGS_KEY_RESERVATION_CONFIRM_URL = 'bookConfirmUrl'
export const SETTINGS_KEY_COMPANY_TELEPHONE = 'companyTelephone'
export const SETTINGS_KEY_BOOK_LIMIT_ENABLED = 'bookLimitEnabled'
export const SETTINGS_KEY_BOOK_LIMIT_DAY = 'bookLimitDay'
export const SETTINGS_KEY_BOOK_LIMIT_HOUR = 'bookLimitHour'
export const SETTINGS_KEY_BOOK_LIMIT_MINUTE = 'bookLimitMinute'
export const SETTINGS_KEY_BOOK_CANCEL_ALLOWED = 'bookCancelAllowed'
export const SETTINGS_KEY_BOOK_CANCEL_LIMIT_DAY = 'bookCancelLimitDay'
export const SETTINGS_KEY_BOOK_CANCEL_LIMIT_HOUR = 'bookCancelLimitHour'
export const SETTINGS_KEY_BOOK_CANCEL_LIMIT_MINUTE = 'bookCancelLimitMinute'
export const SETTINGS_KEY_BOOK_CANCEL_TEXT = 'bookCancelText'
export const SETTINGS_KEY_MEMBER_MESSAGE_POST_MEMBER_REGISTER = 'postMemberRegistrationMessage'
export const SETTINGS_KEY_MEMBER_MESSAGE_RESERVATION = 'bookRegistrationMessage'
export const SETTINGS_KEY_MEMBER_MESSAGE_CAMPAIGN = 'campaignApplyMessage'
export const SETTINGS_KEY_MEMBER_MESSAGE_REMIND1 = 'bookRemind1Message'
export const SETTINGS_KEY_MEMBER_MESSAGE_REMIND2 = 'bookRemind2Message'
export const SETTINGS_KEY_MEMBER_MESSAGE_PRE_EXPIRY = 'memberPreExpiryMessage'
export const SETTINGS_KEY_MEMBER_MESSAGE_EXPIRY_DAY = 'memberExpiryDayMessage'
export const SETTINGS_KEY_MEMBER_MESSAGE_POST_EXPIRY = 'memberPostExpiryMessage'
export const SETTINGS_KEY_MEMBER_MESSAGE_DEACTIVATION = 'memberDeactivationMessage'
export const SETTINGS_KEY_EXPIRY_NOTIFICATION_TIME = 'expiryNotificationTime'
export const SETTINGS_KEY_ADMIN_MESSAGE_MEMBER = 'watchMemberTemplate'
export const SETTINGS_KEY_ADMIN_MESSAGE_CAMPAIGN = 'watchCampaignApplyTemplate'
export const SETTINGS_KEY_ADMIN_MESSAGE_RESERVATION = 'watchRegistrationTemplate'
export const SETTINGS_KEY_ADMIN_MESSAGE_RESERVATION_CANCEL = 'watchRegistrationCancelTemplate'
export const SETTINGS_KEY_BOOK_CANCEL_MESSAGE = 'bookCancelMessage'
export const SETTINGS_KEY_BARCODE_ENABLED = 'isBarcodeEnabled'
export const SETTINGS_KEY_POINT_ENABLED = 'isPointEnabled'
export const SETTINGS_KEY_DATE_OF_EXPIRY_ENABLED = 'isDateOfExpiryEnabled'

/* SETTINGS LABEL */
export const SETTINGS_LABEL_SYSTEM_COLOR = 'システム色'
export const SETTINGS_LABEL_SYSTEM_TITLE = 'システムタイトル'
export const SETTINGS_LABEL_CLIENT_CATEGORIES_SCREEN_TITLE = '予約画面タイトル'
export const SETTINGS_LABEL_CLIENT_CATEGORIES_SCREEN_SUBTITLE = '予約画面サブタイトル'
export const SETTINGS_LABEL_ADMIN_INITIAL_RESERVABLE_COUNT = '予約可能人数の初期値'
export const SETTINGS_LABEL_RESERVATION_CONFIRM_URL = '予約確認URL'
export const SETTINGS_LABEL_COMPANY_TELEPHONE = '問い合わせ電話番号'
export const SETTINGS_LABEL_BOOK_LIMIT_ENABLED = '予約限定'
export const SETTINGS_LABEL_BOOK_LIMIT_DAY = '予約限定日数'
export const SETTINGS_LABEL_BOOK_LIMIT_HOUR = '予約限定時'
export const SETTINGS_LABEL_BOOK_LIMIT_MINUTE = '予約限定分'
export const SETTINGS_LABEL_BOOK_CANCEL_ALLOWED = '予約キャンセル可能'
export const SETTINGS_LABEL_BOOK_CANCEL_LIMIT_DAY = '予約キャンセル限定日'
export const SETTINGS_LABEL_BOOK_CANCEL_LIMIT_HOUR = '予約キャンセル限定時'
export const SETTINGS_LABEL_BOOK_CANCEL_LIMIT_MINUTE = '予約キャンセル限定分'
export const SETTINGS_LABEL_BOOK_CANCEL_TEXT = '予約キャンセル説明文'
export const SETTINGS_LABEL_MEMBER_MESSAGE_POST_MEMBER_REGISTER = '会員証登録後メッセージ'
export const SETTINGS_LABEL_MEMBER_MESSAGE_RESERVATION = '予約メッセージ'
export const SETTINGS_LABEL_MEMBER_MESSAGE_CAMPAIGN = 'キャンペーン応募メッセージ'
export const SETTINGS_LABEL_MEMBER_MESSAGE_REMIND1 = '予約リマインドメッセージ1'
export const SETTINGS_LABEL_MEMBER_MESSAGE_REMIND2 = '予約リマインドメッセージ2'
export const SETTINGS_LABEL_MEMBER_MESSAGE_PRE_EXPIRY = '有効期限1ヶ月前メッセージ'
export const SETTINGS_LABEL_MEMBER_MESSAGE_EXPIRY_DAY = '有効期限当日メッセージ'
export const SETTINGS_LABEL_MEMBER_MESSAGE_POST_EXPIRY = '有効期限2ヶ月後メッセージ'
export const SETTINGS_LABEL_MEMBER_MESSAGE_DEACTIVATION = '無効化通知メッセージ'
export const SETTINGS_LABEL_EXPIRY_NOTIFICATION_TIME = '有効期限通知送信時刻'
export const SETTINGS_LABEL_ADMIN_MESSAGE_MEMBER = '新規メンバーメッセージ'
export const SETTINGS_LABEL_ADMIN_MESSAGE_CAMPAIGN = '新規キャンペーン応募メッセージ'
export const SETTINGS_LABEL_ADMIN_MESSAGE_RESERVATION = '新規予約メッセージ'
export const SETTINGS_LABEL_ADMIN_MESSAGE_RESERVATION_CANCEL = '予約キャンセルメッセージ'

/* SSE LABEL */
export const SSE_SYSTEM_SETTING = 'systemSetting'
export const SSE_FAVICON = 'favicon'
export const SSE_LOGO = 'logo'
export const SSE_STORE_PIC = 'storePic'
export const SSE_CAMPAIGN = 'campaign'
export const SSE_TEMPLATE = 'template'
export const SSE_GIFT = 'gift'
export const SSE_OCCURRENCE = 'occurrence'
export const SSE_REGISTRATION = 'registration'
export const SSE_MEMBER = 'member'
export const SSE_CHAT = 'chat'
export const SSE_CATEGORY = 'category'
export const SSE_OCCASION = 'occasion'
